import Tooltip from '~/components/Tooltip'
import IconPieChart from '~/assets/images/pie-chart.svg'
import {
  StyledDataContainer,
  StyledTitleContainer,
  StyledContent,
} from './styled'
import { DataContainerProps } from './types'

const DataContainer: React.FC<DataContainerProps> = ({
  title,
  description,
  dataTitle,
  subDataTitle,
  middleDataTitle,
  className = '',
  children,
  pie,
  contentStyle,
}) => {
  return (
    <StyledDataContainer className={`data-container ${className}`}>
      <StyledTitleContainer className="title-container">
        <div className="title-with-icon">
          <span className="data-title">{dataTitle}</span>
          {middleDataTitle && (
            <span className="middle-data-title">{middleDataTitle}</span>
          )}
          {title && (
            <Tooltip
              className="icon-exclamation"
              placement="topLeft"
              arrowPointAtCenter
              title={title}
            />
          )}
          {pie && (
            <Tooltip
              className="icon-exclamation-pie"
              title={pie}
              arrowPointAtCenter
              placement="topLeft"
              img={IconPieChart}
              style={{ marginLeft: 8 }}
            />
          )}
        </div>
        {subDataTitle && <span className="sub-title">{subDataTitle}</span>}
      </StyledTitleContainer>
      {children}
      <StyledContent className="content" style={contentStyle}>
        {description}
      </StyledContent>
    </StyledDataContainer>
  )
}

export default DataContainer
